import { render, staticRenderFns } from "./home-static-elements.vue?vue&type=template&id=fefaa1f6&lang=pug&"
import script from "./home-static-elements.vue?vue&type=script&lang=js&"
export * from "./home-static-elements.vue?vue&type=script&lang=js&"
import style0 from "./home-static-elements.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports